import React, { useState } from 'react';
import { Button, Flex } from 'antd';

import ControlSystemCreateModal from '@totem/components/controlSystemReport/ControlSystemCreateModal';
import ControlSystemReportContainer, {
  containerConfiguration,
} from '@totem/components/controlSystemReport/ControlSystemReportContainer';
import NameSearch from '@totem/components/controlSystemReport/NameSearch';
import ReportTable from '@totem/components/controlSystemReport/ReportTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const ControlSystemReportPage = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);

  return (
    <ContentLayout>
      <InputContainer
        filterConfig={containerConfiguration}
        defaultSort={{ field: 'name', direction: 'ascend' }}
        componentKey={'dashboard.controlSystemReport'}
      >
        <ControlSystemReportContainer onRecordTotalChanged={setTotalRecords}>
          <IBCard
            isCovered
            title={'Control System Management'}
            extra={
              <>
                <Button type="primary" onClick={() => setOpen(true)}>
                  Add Control System
                </Button>
              </>
            }
          >
            <Flex justify={'space-between'} align={'center'}>
              <NameSearch />
              <div>
                <RecordCountBadge count={totalRecords} />
              </div>
            </Flex>
            <div style={{ marginTop: '2rem' }}>
              <ReportTable />
            </div>
            {open && (
              <ControlSystemCreateModal
                open={open}
                onClose={() => setOpen(false)}
              />
            )}
          </IBCard>
        </ControlSystemReportContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default ControlSystemReportPage;
